/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

import 'hammerjs';
import { devTools } from '@ngneat/elf-devtools';
import { installConsoleCapture } from 'app/core/debug/console-capture';

// Mirror console.* into memory for the debug "Copy console" button.
installConsoleCapture();

devTools();

import { environment } from './environments/environment';
//console.log('Using environment:', environment);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
